import { useContext } from "react";
import { ff, flags } from 'functions/roleBasedAccessUtils'
import { useSelector } from 'react-redux'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { XMarkIcon, PencilSquareIcon } from "@heroicons/react/20/solid"
import { PlayIcon } from "@heroicons/react/24/outline";
import moment from "moment";

import OrganizationBillingReceiptSectionDropdown from "components/Billing/OrganizationBillingReceiptSectionDropdown";

export default function OrganizationPausedAthletes({
    pausedAthletes = [],
    ShowEditAthleteMembershipModal = () => { },
    ShowOffboardAthleteModal = () => { }
}) {

    const { ShowModal } = useContext(ModalContext)

    const coachId = useSelector((state) => state.user.id)
    const userType = useSelector((state) => state.user.type)
    const adminToolsVisible = useSelector((state) => state.user.adminToolsVisible)
    const organizationId = useSelector((state) => state.user.organizationId)
    const billingLocalTimestamp = useSelector((state) => state.organization.billingLocalTimestamp)

    const canAccessSidebarSalesTools = ff(flags.canAccessSidebarSalesTools, { userType: userType, adminToolsVisible: adminToolsVisible })

    const OnAthletePressed = (userId) => {
        const url = `/athlete/${userId}`
        window.open(url, '_blank')
    }

    const ShowResumeAthleteModalWarning = (athlete) => {
        const modalData = {
            key: ModalKey.ActionWarning,
            size: 'quarter',
            titleText: `Resume ${athlete.firstName} ${athlete.lastName}?`,
            bodyText: [
                'This athlete will be added back into your bill',
            ],
            buttonText: 'Resume Athlete',
            buttonAction: async () => await ResumeAthlete(athlete)
        }

        ShowModal(modalData)
    }

    const ResumeAthlete = async (athlete) => {
        const jsonBody = {
            userId: coachId,
            organizationId: organizationId,
            athleteId: athlete.id,
            athleteStatus: athlete.status,
            membershipAction: 'reactivate',
            localDateString: billingLocalTimestamp.format('YYYY-MM-DD'),
            utcOffsetMinutes: moment().utcOffset(), // UTC offset in minutes for timezone-aware date calculations
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('BILLING', 'POST', '/update_organization_membership', jsonBody)

        // console.log(result)

        if (result.data.status === 'failure') {
            console.error(result)
            return
        }

        window.location.reload()
    }

    // console.log(pausedAthletes);

    if (pausedAthletes.length === 0) return null;

    return (
        <OrganizationBillingReceiptSectionDropdown
            title="Paused Athletes"
            subTitle={`${pausedAthletes.length} athlete${pausedAthletes.length > 1 ? 's' : ''}`}
        >
            {pausedAthletes.map((athlete, index) => (
                <div
                    key={index}
                    className="flex items-center"
                >
                    <div
                        className='flex-grow flex items-center pl-4 py-4 bg-gray-50 cursor-pointer'
                        onClick={() => OnAthletePressed(athlete.id)}
                    >
                        {canAccessSidebarSalesTools &&
                            <div
                                className="-ml-4 -my-4 h-12 w-10 flex items-center justify-center"
                                onClick={(e) => { e.stopPropagation(); ShowEditAthleteMembershipModal(athlete) }}
                            >
                                <PencilSquareIcon className="ml-1 h-5 w-5 text-gray-400" />
                            </div>
                        }

                        <div className="text-sm pr-1">{athlete.firstName} {athlete.lastName}</div>

                        <div className="text-sm text-gray-500">
                            {athlete.email && <>({athlete.email})</>}
                            {!athlete.email && <>(No Email)</>}
                        </div>

                        <div className="flex-1" />

                        {athlete.pauseEndDate &&
                            <>
                                {(() => {
                                    // Add 1 day to the pause days remaining to account for the current day
                                    const pauseDaysRemaining = moment(athlete.pauseEndDate).local().diff(billingLocalTimestamp, 'days') + 1;

                                    return (
                                        <div className="pr-2">
                                            <div className="px-2 bg-blue-50 text-blue-700 rounded text-xs font-medium whitespace-nowrap border border-blue-200">
                                                {pauseDaysRemaining} day{pauseDaysRemaining > 1 ? 's' : ''} remaining
                                            </div>
                                        </div>
                                    )
                                })()}

                                <div className="text-sm text-gray-500 text-right pr-2">
                                    Pause ends on {moment(athlete.pauseEndDate).local().format('MMMM D, YYYY')}
                                </div>
                            </>
                        }

                        {!athlete.pauseEndDate &&
                            <div className="px-2 bg-blue-50 text-blue-700 rounded text-xs font-medium whitespace-nowrap border border-blue-200 mr-2">
                                Ongoing
                            </div>
                        }

                        <div className="text-sm">${athlete.price.toFixed(2)}</div>
                    </div>

                    <div className="p-4 bg-gray-50 flex items-center gap-x-2">
                        <div
                            className="text-gray-400 cursor-pointer hover:text-gray-600"
                            onClick={() => ShowResumeAthleteModalWarning(athlete)}
                        >
                            <PlayIcon className="h-5 w-5" />
                        </div>

                        <div
                            className="bg-gray-50 text-gray-400 cursor-pointer hover:text-gray-600"
                            onClick={() => ShowOffboardAthleteModal(athlete)}
                        >
                            <XMarkIcon className="h-5 w-5" />
                        </div>
                    </div>
                </div>
            ))}
        </OrganizationBillingReceiptSectionDropdown>
    )
}